import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeRumPublicApi, startRum } from '@datadog/browser-rum-core';
export var datadogRum = makeRumPublicApi(startRum);
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);